<template>
    <div class="wrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 4.8vw 7.733vw;">
            <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>How to place</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="font-weight: bold;font-size: 5.333vw;margin: 5.333vw 7.733vw;">
            How to place
        </div>
        <div class="sp" @click="active1 = !active1">
            <div>
                1 Step One
            </div>
            <div>Sign up <i class="el-icon-arrow-down" v-if="!active1"></i><i class="el-icon-arrow-up" v-if="active1"></i>
            </div>
        </div>
        <div class="cont" v-if="active1">
            <div style="font-size: 3.733vw;">"Before placing an order, please ensure you have a GiGwi account. (If you
                already have an account, you may
                skip this step and proceed to Step 2.)"</div>
            <div class="tit">1.1 Register an account.
                <div style="font-size: 3.733vw;">Click to enter the "sign up" page from the navigation bar.</div>
            </div>
            <div style="display: flex;justify-content: center;margin: 4.267vw 0;">
                <img src="../assets/imgs/uploads/image 23.png" style="width: 72.533vw;height: 134.667vw;" alt="">
            </div>
            <div style="display: flex;justify-content: center;margin: 4.267vw 0;">
                <img src="../assets/imgs/uploads/image 24.png" style="width: 72.533vw;height: 134.667vw;" alt="">
            </div>
            <div style="font-size: 3.733vw;font-weight: bold;">
                Please provide the required information step by step. Ensure that your details are clear and thorough.
                Fields marked with an asterisk (*) are mandatory.
            </div>
            <div style="display: flex;justify-content: center;margin: 4.267vw 0;">
                <img src="../assets/imgs/uploads/image 25.png" style="width: 72.533vw;height: 134.667vw;" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active1: false,
        };
    }
}
</script>

<style scoped>
.wrapper {
    width: 100vw;
    margin: 0 auto 23.733vw;
    font-size: 16px;
}

.sp {
    width: 100vw;
    height: 9.333vw;
    background-color: #CA141D;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    font-size: 3.733vw;
    color: #fff;
    padding: 0 7.2vw 0 2.4vw;
}

.cont {
    background-color: #FFF3F2;
    border: 2px solid #CA141D;
    border-top: none;
    padding: 6.667vw 7.2vw;
}

.cont .tit {
    font-weight: bold;
    margin: 4.8vw auto 6px;
}
</style>